const { html } = window;

export default () => `
<div class="row">
    <div class="large-12">
        <h1 class="text-center Browse-heading">${html('browseSubjects.title')}</h1>
    </div>
</div>

<div class="row">
    <div class="large-12">
        <div class="js-formats"></div>
    </div>
</div>

<div class="row" role="tabpanel">
    <div class="large-12">
        <div class="js-seeAll"></div>
        <div aria-live="polite" class="js-subjects"></div>
    </div>
</div>
`;
